var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"fill-height login-bg",attrs:{"fluid":""}},[_vm._t("default",null,{"transition":"slide-y-transition"})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }